module.exports = __webpack_public_path__ + "img/scb.defbb762.svg";